import request from '@/utils/httpClient'

export interface DropdownOptionModel {
  id: number;
  mark: string;
}

export declare type DropdownType = 'ReviewStatus' | 'Status' | 'DeptNature' | 'DataAuthority' | 'AccessType' | 'UserPayType' | 'Marriage' | 'Education' | 'Sex' | 'CommissionType' | 'TaxType' | 'RateType' | 'HttpMethodType' | 'AchieveType'

// 根据type值获取对应的下拉枚举
export function getDropdownByType(type: DropdownType): Promise<Array<DropdownOptionModel>> {
  return request({
    url: `dropdown/${type}`,
    method: 'get'
  })
}

// 设置自定义列
export function tableSetting(data: any) {
  return request({
    url: 'tableSetting',
    method: 'post',
    data
  })
}

// 获取自定义列
export function getTableColumnList(tableName: string) {
  return request({
    url: `tableSetting/${tableName}`,
    method: 'get'
  })
}
